import { render, staticRenderFns } from "./EditProduct.vue?vue&type=template&id=1f5dc7f4&"
import script from "./EditProduct.vue?vue&type=script&lang=js&"
export * from "./EditProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f5dc7f4')) {
      api.createRecord('1f5dc7f4', component.options)
    } else {
      api.reload('1f5dc7f4', component.options)
    }
    module.hot.accept("./EditProduct.vue?vue&type=template&id=1f5dc7f4&", function () {
      api.rerender('1f5dc7f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/rawmaterials/EditProduct.vue"
export default component.exports